
namespace Gamification.Gamification {

    @Serenity.Decorators.registerFormatter()
    export class SlickGridCheckFormatter implements Slick.Formatter {

        @Serenity.Decorators.option()
        public dummy: string;

        format(ctx: Slick.FormatterContext) {

            var sOutput = "";

            if (ctx.value !== null) {
                if (ctx.value > 0)
                    sOutput = '<div class="d-flex align-items-center justify-content-center"><i class="icon fa fa-check fa-1x"> </i></div>';
            }

            return sOutput;                
        }
    }
}